(() => {
  const selector = '.sm-doom-drones-3-hero .product-form__submit, .sm-dd3-launch__button--film, .sm-mw-farewell__hotspot';
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  function init(root = document) {
    root.querySelectorAll(selector).forEach(button => {
      if (button.classList.contains('sm-dd3-noise-ready')) return;
      const film = button.matches('.sm-dd3-launch__button--film');
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      if (!ctx) return;
      canvas.className = 'sm-dd3-random-noise';
      canvas.setAttribute('aria-hidden', 'true');
      button.append(canvas);
      button.classList.add('sm-dd3-noise-ready');
      let timer = null, hovering = false;
      let dustFrame = null, dustTime = 0, dustCanvas, dustCtx, motes = [], bug = null, nextBug = 0;
      if (film) {
        dustCanvas = document.createElement('canvas');
        dustCanvas.className = 'sm-film-dust';
        dustCanvas.setAttribute('aria-hidden', 'true');
        dustCtx = dustCanvas.getContext('2d');
        if (dustCtx) button.append(dustCanvas);
      }
      function drawDust(now) {
        dustFrame = null;
        if (!dustCtx || !active()) return;
        const w = Math.max(1, Math.round(button.clientWidth * 1.24)), h = 85;
        if (dustCanvas.width !== w) { dustCanvas.width = w; dustCanvas.height = h; motes = []; }
        const dt = Math.min((now - dustTime) / 1000 || 0, .05); dustTime = now;
        while (motes.length < 32) motes.push({x:Math.random()*w,y:Math.random()*h,vx:(Math.random()-.5)*10,vy:-3-Math.random()*8,r:.35+Math.random()*.7,a:.16+Math.random()*.4,phase:Math.random()*6.28});
        dustCtx.clearRect(0,0,w,h);
        for (const p of motes) {
          if (!reduced.matches) { p.x += (p.vx + Math.sin(now*.0008+p.phase)*3)*dt; p.y += p.vy*dt; }
          if (p.y < -2) { p.y=h; p.x=Math.random()*w; }
          if (p.x < 0) p.x=w; if (p.x>w) p.x=0;
          const half=5+(1-p.y/h)*w*.48;
          const light=Math.max(0,1-Math.abs(p.x-w/2)/half);
          dustCtx.fillStyle='rgba(225,239,224,'+(p.a*light)+')';
          dustCtx.beginPath(); dustCtx.arc(p.x,p.y,p.r,0,Math.PI*2); dustCtx.fill();
        }
        if (!reduced.matches && now>nextBug && !bug) {
          bug={x:-4,y:20+Math.random()*35,v:32+Math.random()*24,phase:Math.random()*6.28};
          nextBug=now+7000+Math.random()*10000;
        }
        if (bug) {
          bug.x+=bug.v*dt;
          const y=bug.y+Math.sin(bug.x*.09+bug.phase)*5;
          const light=Math.max(0,1-Math.abs(bug.x-w/2)/(5+(1-y/h)*w*.48));
          dustCtx.fillStyle='rgba(231,240,221,'+(light*.65)+')';
          dustCtx.fillRect(bug.x,y,1.5,1);
          dustCtx.globalAlpha=.5;
          dustCtx.fillRect(bug.x-1,y+(Math.sin(now*.09)>0?-1:1),1,1);
          dustCtx.fillRect(bug.x+2,y+(Math.sin(now*.09)>0?-1:1),1,1);
          dustCtx.globalAlpha=1;
          if(bug.x>w+4)bug=null;
        }
        if (!reduced.matches) dustFrame=requestAnimationFrame(drawDust);
      }
      const active = () => button.isConnected && !button.disabled && !document.hidden && (hovering || button.matches(':focus-visible'));
      function paint() {
        const w = Math.max(1, Math.round(button.clientWidth - 2));
        const h = Math.max(1, Math.round(button.clientHeight - 2));
        if (canvas.width !== w || canvas.height !== h) { canvas.width = w; canvas.height = h; }
        const frame = ctx.createImageData(w, h);
        const data = frame.data;
        for (let i = 0; i < data.length; i += 4) {
          data[i] = film ? 215 : 240; data[i + 1] = film ? 237 : 69; data[i + 2] = film ? 230 : 69;
          data[i + 3] = Math.random() < .68 ? Math.floor(Math.random() * 40) : 0;
        }
        ctx.putImageData(frame, 0, 0);
        const specks = 5 + Math.floor(Math.random() * 7);
        for (let i = 0; i < specks; i++) {
          ctx.fillStyle = 'rgba(255,255,255,' + (.25 + Math.random() * .4) + ')';
          ctx.fillRect(Math.floor(Math.random() * w), Math.floor(Math.random() * h), Math.random() < .12 ? 2 : 1, 1);
        }
        if (Math.random() < .18) {
          ctx.fillStyle = film ? 'rgba(215,237,230,.17)' : 'rgba(240,68,68,.17)';
          ctx.fillRect(Math.floor(Math.random() * w), Math.floor(Math.random() * h), 3 + Math.floor(Math.random() * 9), 1);
        }
      }
      function stop() { clearTimeout(timer); timer = null; cancelAnimationFrame(dustFrame); dustFrame = null; }
      function tick() {
        timer = null;
        if (!active()) return;
        paint();
        if (!reduced.matches) timer = setTimeout(tick, 75 + Math.random() * 95);
      }
      function sync() { stop(); if (active()) { tick(); if (dustCtx) { dustTime=performance.now(); if (!nextBug) nextBug=dustTime+2200+Math.random()*3000; drawDust(dustTime); } } }
      button.addEventListener('pointerenter', event => { if (event.pointerType !== 'touch') { hovering = true; sync(); } });
      button.addEventListener('pointerleave', () => { hovering = false; sync(); });
      button.addEventListener('focus', sync);
      button.addEventListener('blur', sync);
      document.addEventListener('visibilitychange', sync);
      reduced.addEventListener('change', sync);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once:true});
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();